'use client'

import { createContext, use, useState, useEffect, ReactNode } from 'react'
import {
  CLOSET_AUTH_CHANGE_EVENT,
  readClosetAuthToken,
} from '@/lib/closet/client-auth'

interface ClosetAuthContextType {
  isAuthenticated: boolean
}

const ClosetAuthContext = createContext<ClosetAuthContextType>({
  isAuthenticated: false,
})

export const useClosetAuth = () => use(ClosetAuthContext)

export function ClosetAuthProvider({ children }: { children: ReactNode }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false)

  useEffect(() => {
    const syncFromStorage = () => setIsAuthenticated(!!readClosetAuthToken())
    syncFromStorage()

    // `storage` covers other tabs; CLOSET_AUTH_CHANGE_EVENT covers this one,
    // which the native event deliberately skips.
    window.addEventListener('storage', syncFromStorage)
    window.addEventListener(CLOSET_AUTH_CHANGE_EVENT, syncFromStorage)
    return () => {
      window.removeEventListener('storage', syncFromStorage)
      window.removeEventListener(CLOSET_AUTH_CHANGE_EVENT, syncFromStorage)
    }
  }, [])

  return (
    <ClosetAuthContext.Provider value={{ isAuthenticated }}>
      {children}
    </ClosetAuthContext.Provider>
  )
}
